<div *ngIf="isDataLoaded" [@creFadeInOut]>
  <span class="cre-wig-fleet-competition-trend-title" *ngIf="!!battleTitle"
    >{{ battleTitle }} for {{ fleet }}</span
  >
  <div class="cre-wig-fleet-competition-trend-graph-container">
    <p-chart
      [data]="chartData"
      height="100%"
      [options]="chartOptions"
      type="line"
      width="100%"
    ></p-chart>
    <div class="overlay-no-data" *ngIf="!hasData">
      <div class="no-data">
        <span
          ><fa-icon class="cre-stat-panel-value" [icon]="['fal', 'gas-pump-slash']"></fa-icon
        ></span>
        <div class="no-data-available">
          <span class="no-data-available">No Data Available</span>
          <span class="check-later">There is no data to show. Please check back later.</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="p-grid p-justify-center">
  <cre-spinner [size]="'md'" [hidden]="isDataLoaded"></cre-spinner>
</div>
